import DepartmentList from './department_list';

export default DepartmentList;
